import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { injectIntl } from 'react-intl'
import { Textarea, Checkbox } from 'components/fields'

@injectIntl
class SignOff extends Component {
  static propTypes = {
    intl: PropTypes.object,
    isRejecting: PropTypes.bool,
    onReject: PropTypes.func,
    isAssessorReportAdditionalInfoEnabled: PropTypes.bool
  }

  static defaultProps = {
    prefix: null,
    storeRemoved: false
  }

  render() {
    const { intl, onReject, isRejecting, isAssessorReportAdditionalInfoEnabled } = this.props

    return (
      <div>
        {!isRejecting && (
          <div>
            <div className="row">
              <div className="col-xs-12">
                <Textarea
                  name="assessorReport"
                  label="Assessor report"
                  intlKey="label.assessor_report"
                  placeHolder={intl.formatMessage({
                    defaultMessage:
                      "Please comment on the participant's improvement/performance commitment",
                    id: 'label.comment_on_participant_improvement'
                  })}
                />
              </div>
              {isAssessorReportAdditionalInfoEnabled &&  <div className="col-xs-12">
                <Textarea
                  name="assessorReportAdditionalInfo"
                  label=""
                  placeHolder={intl.formatMessage({
                    defaultMessage:
                      "Please comment on how the Participant demonstrated effort working towards the goal for the activity",
                    id: 'label.comment_on_participant_effort'
                  })}
                />
              </div>}
            </div>

            <div className="row">
              <div className="col-xs-12">
                <Checkbox
                  name="helpers.requirements"
                  label="I Certify That as the Assessor of this activity that the participant has met the requirements."
                  intlKey="label.certify_participant_met_reqs"
                />
              </div>
            </div>

            <div className="row" style={{ marginTop: 50 }}>
              <div className="col-xs-12">
                <p className="note">
                  Or don't agree? You can{' '}
                  <span className="link" onClick={onReject}>
                    reject this application
                  </span>.
                </p>
              </div>
            </div>
          </div>
        )}
        {isRejecting && (
          <Textarea name="note" label="Reason" intlKey="label.reason" />
        )}
      </div>
    )
  }
}

export default SignOff
